import { createStore, applyMiddleware } from "redux";
import rootReducer from "./rootReducer";
import { fetchCourses } from "./courses/courseActions";
import { fetchSemPeriods } from "./sem_periods/semPeriodActions";
import { thunk } from "redux-thunk";

const store = createStore(rootReducer, applyMiddleware(thunk));
store.dispatch(fetchCourses());
store.dispatch(fetchSemPeriods());

export default store;
